import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // list
    fetchBanks(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/settings/banks", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchReceiveMethods(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/settings/receive_methods", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchClaimStatuses(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("claim_statuses", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchExpenseStatuses(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("expense_statuses", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchPrepaymentStatuses(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("prepayment_statuses", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // show fetch specifi
    fetchBank(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/settings/banks/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchClaimStatus(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`claim_statuses/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchExpenseStatus(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`expense_statuses/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchPrepaymentStatus(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`prepayment_statuses/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // store
    editBank(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/settings/banks", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editReceiveMethod(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/settings/receive_methods", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editClaimStatus(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("claim_statuses", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editExpenseStatus(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("expense_statuses", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editPrepaymentStatus(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("prepayment_statuses", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },


    // // delete
    deleteBank(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/settings/banks", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteReceiveMethod(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/settings/receive_methods", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteClaimStatus(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("claim_statuses", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteExpenseStatus(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("expense_statuses", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deletePrepaymentStatus(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("prepayment_statuses", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
